<template>
    <div>
       <h3 class="text-center">Great, Your email is verified, we are logging in now</h3>
       <div class="text-center">
           <font-awesome-icon
                   v-if="loading"
                   icon="spinner"
                   class="fa-spin fa-2x"
           />
       </div>
    </div>
</template>
<script>

    export default{
        data(){
           return {
               loading: true
           }
        },
        created() {
            setTimeout(() => {
                window.location.href='/supplier/dashboard'
            }, 10 * 20)
        }
    }
</script>
